// TableHeader.tsx old
import { Fragment, useEffect, useState } from "react";
import TableBody from "./TableBody";
import { TableDetailsItem, tableMinWidth } from "./tableFunctions";
import Image from "../images/Image";
import { getFirefoxCssFix } from "../commonfunctions/getFirefoxCssFix";
import useTranslation from "../CustomHooks/useTranslation";
import { adminContents } from "../../pages/AdminManagement/components/AdminManagementContent";
import { RootState } from "../../store";
import { useSelector } from "react-redux";

interface TableHeaderProps {
  loading: boolean;
  TableDetails: TableDetailsItem;
  handleActions: (id: string, key: string, text?: string) => void;
  handleSort?: (key: string) => void;
  getList?: () => void;
  searchParams?: URLSearchParams;
  listData?: unknown[];
  hasActivateDeactivateMDPrivilege?: boolean;
  hasViewMDPrivilege?: boolean;
  hasEditMDPrivilege?: boolean;
  mnoList?: boolean;
  amountList?: boolean;
  TabChildren?: boolean;
  mainEndPoint?: string;
  stickyStyleTableHeader?: string;
}

const TableHeader = ({
  loading,
  listData,
  TableDetails,
  handleActions,
  searchParams,
  handleSort,
  getList,
  hasActivateDeactivateMDPrivilege,
  hasViewMDPrivilege,
  hasEditMDPrivilege,
  mnoList,
  amountList,
  stickyStyleTableHeader,
  mainEndPoint,
  TabChildren,
}: TableHeaderProps) => {
  const [isSafari, setIsSafari] = useState(false);
  const tableHeaders = Object.entries(TableDetails);
  const currentSort = searchParams?.get("sort");
  const { translate, notEnglish } = useTranslation(adminContents);
  const [isFirefox, setIsFirefox] = useState(false);
  const { activeList } = useSelector((state: RootState) => state.activeList);
  useEffect(() => {
    setIsFirefox(navigator.userAgent.toLowerCase().includes("firefox"));
  }, []);
  useEffect(() => {
    // Detect Safari browser
    const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(
      navigator.userAgent
    );
    setIsSafari(isSafariBrowser);
  }, []);

  const getSortOrder = (key: string) => {
    if (currentSort) {
      const sortArray = currentSort.split(",");
      const existingSort = sortArray.find((s) => s.startsWith(key));
      if (existingSort) {
        return existingSort.endsWith("asc") ? "asc" : "desc";
      }
    }
    return null;
  };

  // Function to get Safari-specific styles
  const getSafariStyles = (isHeader: boolean) => {
    if (!isSafari) return "";
    return isHeader ? "border-b border-primary_text" : "";
  };

  // Function to handle RTL layout for Safari
  const getHeaderOrder = (index: number) => {
    if (!isSafari || !notEnglish) return "";
    return `order-${tableHeaders.length - index}`;
  };
  return (
    <div
      className={`block ${TabChildren
        ? loading
          ? "h-childernTabHight2 overflow-hidden"
          : `h-childernTabHight overflow-auto ${getFirefoxCssFix("scroll")}`
        : amountList
          ? loading
            ? "overflow-hidden"
            : `${mainEndPoint === 'cash-in' ? 'h-amountTableHeight1 overflow-y-auto overflow-x-hidden' : 'h-amountTableHeight overflow-auto'}  ${getFirefoxCssFix("scroll")}`
          : loading
            ? "overflow-hidden"
            : `h-tableHeight overflow-auto ${getFirefoxCssFix("scroll")}`
        } ${tableHeaders.length - 1 && loading ? "border-b border-primary_text" : ""
        }`}
    >
      <div>
        <table className="border-collapse table-auto w-full text-left">
          <thead dir={notEnglish && !isSafari ? "rtl" : "ltr"}>
            <tr
              className={`top-[-1px] left-0 sticky z-[10]`}
              dir={notEnglish && isSafari ? "rtl" : ""}
            >
              {tableHeaders.map(([header, details], indexTable = 0) => (
                <Fragment key={indexTable + "indexTable"}>
                  {details.id !== "actions" ? (
                    <th
                      className={` text-nowrap  text-left 
                        ${getFirefoxCssFix("tableBorder")} 
                        ${indexTable === tableHeaders.length - 2 && !isFirefox
                          ? "border border-y-0 border-r-0 tableBorderheading"
                          : indexTable !== tableHeaders.length - 2 &&
                            !isFirefox
                            ? "border border-y-0 tableBorderheading"
                            : indexTable === tableHeaders.length - 2 &&
                              isFirefox
                              ? "border-y border-r-0"
                              : "border"
                        }
                        text-large relative border-primary_text 
                        ${tableMinWidth(details.id)} 
                        ${details.className || ""}
                        // ${getSafariStyles(true)}
                        ${getHeaderOrder(indexTable)}
                        ${notEnglish && isSafari ? "flex-1" : ""}
                      `}
                    >
                      <span className="flex bg-white items-center p-1.5 ">
                        {loading ? (
                          <div className="h-[24px] w-full bg-gray-200 rounded animate-pulse"></div>
                        ) : (
                          <>
                            {translate(header)}
                            {details.sort && (
                              <div
                                className={`${getSortOrder(details.id) === "desc"
                                  ? "rotate-180"
                                  : ""
                                  }`}
                              >
                                <Image
                                  src={
                                    getSortOrder(details.id)
                                      ? "sort"
                                      : "inactive_sort"
                                  }
                                  testId={`sort_${details.id}`}
                                  onClick={() =>
                                    handleSort ? handleSort(details.id) : {}
                                  }
                                  className={`h-5 w-5 ${!loading ? "cursor-pointer" : ""
                                    }`}
                                />
                              </div>
                            )}
                          </>
                        )}
                      </span>
                    </th>
                  ) : (
                    <th
                      className={`sticky  text-center px-[0.1px] ${isFirefox ? "border border-primary_text" : ""
                        } text-large ${loading ? '' : 'right-0'}  bg-white 
                        ${notEnglish && isSafari ? "flex-none" : ""}
                      `}
                    >
                      <span
                        className={`text-center ${isFirefox ? "" : "border bg-white border-primary_text"
                          } mb-[-2px] ${activeList === "Pending"
                            ? "left-[-2px]"
                            : (mainEndPoint === 'cash-in' && !loading) ? 'left-[1px]' : "left-[-1px]"
                          } right-[2px] relative ${loading ? 'px-2' : 'px-4'} py-2 flex justify-center`}
                      >
                        {loading ? (
                          <div className="h-[24px] w-full bg-gray-200 rounded animate-pulse"></div>
                        ) : (
                          details?.actionTypes.length > 1
                            ? translate("Actions")
                            : translate("Action")
                        )}
                      </span>
                    </th>
                  )}
                </Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              // Skeleton loading rows
              Array.from({ length: 10 }).map((_, index) => (
                <tr key={index}>
                  {tableHeaders.map(([key, details], tdIndex = 0) => (
                    <Fragment key={`${key}-${index}`}>
                      {/* {details.id === "actions" && !details.custom ? (
                        <td
                          className={`text-body2 px-[0.1px] ${tableMinWidth(
                            details.id
                          )}
                          sticky right-0 bg-white`}
                        >
                          <div
                            className={`tableBorderBody ${index < 9 ? " border-b border-primary_text " : ""
                              } relative px-4 py-2 flex bg-white`}
                          >
                            <div className="flex gap-[14px] mx-auto">
                              {details.actionTypes.map((imgItem: string) => (
                                <Image
                                  src={`${imgItem.toLocaleLowerCase()}Img`}
                                  key={imgItem}
                                  className="z-50"
                                  tableActions={true}
                                />
                              ))}
                            </div>
                          </div>
                        </td>
                      ) : ( */}
                      <td
                        className={`animation-plus text-body2 ${mainEndPoint?.includes('service-fee') ? 'p-2' : 'p-1.5'} 
                          ${tableMinWidth(details.id)} 
                          ${tdIndex === 0 ? "border-t-0" : ""} 
                          
                          ${tdIndex === tableHeaders.length - 2 && index !== 9
                            ? "border-b"
                            : tdIndex !== tableHeaders.length - 2 &&
                              index !== 9
                              ? "border-x border-b"
                              : "border-x"
                          }
                          ${index === 9 ? "" : ""} border-primary_text  
                           ${details.className || ""}`}
                      >
                        <div className="h-[30px] bg-gray-200 rounded"></div>
                      </td>
                    </Fragment>
                  ))}
                </tr>
              ))
            ) : listData && listData.length > 0 ? (
              <>
                {listData.map((item, index) => (
                  <tr key={index}>
                    <TableBody
                      tableBodyItem={item as Record<string, any>}
                      TableDetails={TableDetails}
                      tableBodyIndex={index}
                      handleActions={handleActions}
                      getList={getList}
                      hasActivateDeactivateMDPrivilege={
                        hasActivateDeactivateMDPrivilege
                      }
                      listData={listData}
                      hasViewMDPrivilege={hasViewMDPrivilege}
                      hasEditMDPrivilege={hasEditMDPrivilege}
                      mnoList={mnoList}
                      mainEndPoint={mainEndPoint}
                    />
                  </tr>
                )
                )}
                <tr className="py-4 h-8"></tr>
              </>
            ) : (
              <tr>
                <td colSpan={tableHeaders.length} className="py-4 text-center">
                  {translate("No data available")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableHeader;
